import { addressDrawerPickUpLocationSelectorStyles as styles } from "@insite/content-library/Widgets/Header/AddressDrawerPickUpLocationSelector";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.changeLink = {
    ...styles.changeLink,
    css: css`
        ${styles.changeLink?.css}
        margin-left: 0;
        margin-bottom: 16px;
    `,
};

styles.headerText = {
    ...styles.headerText,
    css: css`
        ${styles.headerText?.css}
        margin-top: 16px;
        display: inline-block;
        color: ${getColor(colorStrings.textMain)} !important;
    `,
};
